import { BlurView } from "expo-blur";
import { YStack } from "tamagui";
import { Toast, useToastState } from "@tamagui/toast";
export const NativeToast = () => {
  const currentToast = useToastState();
  if (!currentToast || currentToast.isHandledNatively) {
    return null;
  }
  return <Toast key={currentToast.id} viewportName={currentToast.viewportName} enterStyle={{
    opacity: 0,
    scale: 0.5,
    y: -25
  }} exitStyle={{
    opacity: 0,
    scale: 1,
    y: -20
  }} y={0} opacity={1} scale={1} transition="quick" bc="$background" borderRadius="$12" boxShadow="0px 0px 16px $shadowColor" p={0} mx="$4" duration={currentToast.duration} borderColor="$strokeSecondary" borderWidth="$0.5" data-sentry-element="Toast" data-sentry-component="NativeToast" data-sentry-source-file="NativeToast.tsx">
      <YStack overflow="hidden"
    // Values repeated with Toast because of the way overflow "hidden" works with BlurView and box shadow
    boxShadow="0px 0px 16px $shadowColor" borderRadius="$12" data-sentry-element="YStack" data-sentry-source-file="NativeToast.tsx">
        <BlurView tint="light" intensity={70} style={{
        overflow: "hidden"
      }} data-sentry-element="BlurView" data-sentry-source-file="NativeToast.tsx">
          <YStack px="$4.5" py="$4" data-sentry-element="YStack" data-sentry-source-file="NativeToast.tsx">
            {/* eslint-disable-next-line react/forbid-component-props */}
            <Toast.Title ta="center" fontWeight="500" pb="$1" data-sentry-element="Toast.Title" data-sentry-source-file="NativeToast.tsx">
              {currentToast.title}
            </Toast.Title>
            {currentToast.message ? <Toast.Description ta="center" size="$3" color="$textSubtle">
                {currentToast.message}
              </Toast.Description> : null}
          </YStack>
        </BlurView>
      </YStack>
    </Toast>;
};